import {Component} from "react";
import {Table} from "react-bootstrap";
import PasswordCheckStatusImage from "./PasswordCheckStatusImage";
import {PasswordRequirementNames, PasswordScore} from "../CalculatePasswordScore";

export interface PasswordDeductionsProps{
    score: PasswordScore
}
export default class PasswordDeductions extends Component<PasswordDeductionsProps> {

    render() {
        const showScore = (score: number | undefined) => (score || 0) > 0 ? `-${score}` : `${score}`;
        const requirementsTableRow = (requirement: PasswordRequirementNames, otherRows: JSX.Element) => {
            return <>
                <td><PasswordCheckStatusImage status={this.props.score.requirements[requirement].status} /></td>
                {otherRows}
                <td><div>{this.props.score.requirements[requirement].count}</div></td>
                <td className={this.props.score.requirements[requirement].status}>{showScore(this.props.score.requirements[requirement].score)}</td>
            </>
        }
        return <>
            <Table bordered className="score-details">
                <thead>
                <tr>
                    <th colSpan={2}>Deductions</th>
                    <th>Type</th>
                    <th>Rate</th>
                    <th>Count</th>
                    <th>Bonus</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    {requirementsTableRow('LettersOnly',<>
                        <td>Letters Only</td>
                        <td>Flat</td>
                        <td>-n</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('NumbersOnly',<>
                        <td>Numbers Only</td>
                        <td>Flat</td>
                        <td>-n</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('RepeatCharacters',<>
                        <td>Repeat Characters (Case Insensitive)</td>
                        <td>Comp</td>
                        <td>&nbsp;-</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('ConsecutiveUppercaseLetters',<>
                        <td>Consecutive Uppercase Letters</td>
                        <td>Flat</td>
                        <td>-(n*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('ConsecutiveLowercaseLetters',<>
                        <td>Consecutive Lowercase Letters</td>
                        <td>Flat</td>
                        <td>-(n*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('ConsecutiveNumbers',<>
                        <td>Consecutive Numbers</td>
                        <td>Flat</td>
                        <td>-(n*2)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('SequentialLetters',<>
                        <td>Sequential Letters (3+)</td>
                        <td>Flat</td>
                        <td>-(n*3)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('SequentialNumbers',<>
                        <td>Sequential Numbers (3+)</td>
                        <td>Flat</td>
                        <td>-(n*3)</td>
                    </>)}
                </tr>
                <tr>
                    {requirementsTableRow('SequentialSymbols',<>
                        <td>Sequential Symbols (3+)</td>
                        <td>Flat</td>
                        <td>-(n*3)</td>
                    </>)}
                </tr>
                </tbody >
            </Table >
        </>
    }
}
